// Zimmet durumları
export enum AssetStatus {
  ASSIGNED = 'ASSIGNED',
  RETURNED = 'RETURNED'
}

// Zimmet (Asset) temel tipi
export interface Asset {
  id: number;
  name: string;
  serialNumber: string;
  status: AssetStatus;
  userId: number;
  createdAt: string;
  updatedAt: string;
  user?: {
    id: number;
    name?: string;
    email?: string;
  };
}

// Yeni zimmet oluşturma için request tipi
export interface CreateAssetRequest {
  name: string;
  serialNumber: string;
  userId: number;
}

// Zimmet durumu güncelleme için request tipi
export interface UpdateAssetStatusRequest {
  status: AssetStatus;
}

// API response tipleri
export interface AssetResponse {
  success: boolean;
  message: string;
  data: Asset;
}

export interface AssetsResponse {
  success: boolean;
  message: string;
  data: Asset[];
}

// Zimmet listesi için filtre tipi
export interface AssetFilters {
  userId?: number;
  status?: AssetStatus;
  search?: string;
}



// Zimmet form verisi tipi
export interface AssetFormData {
  name: string;
  serialNumber: string;
  userId: number | null;
}

// Zimmet tablosu için kolon tipi
export interface AssetTableColumn {
  key: string;
  label: string;
  sortable?: boolean;
  width?: string;
}

// Zimmet modal tipleri
export interface AssetModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: CreateAssetRequest) => Promise<void>;
  employees: { id: number; name: string; email: string }[];
  isLoading?: boolean;
}

export interface AssetUpdateModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (assetId: number, status: AssetStatus) => Promise<void>;
  asset: Asset | null;
  isLoading?: boolean;
}

// Zimmet detay sayfası için props
export interface AssetDetailProps {
  assetId: number;
}

// Çalışan zimmet listesi için props
export interface EmployeeAssetListProps {
  userId: number;
  userName?: string;
  showActions?: boolean;
  compact?: boolean;
}

// API Error tipi
export interface AssetError {
  success: false;
  message: string;
  error?: string;
} 